module.exports = __webpack_public_path__ + "img/6.30cfbe94.jpg";